'use strict';
const options_collection = {
  collectionsLoadMore: '.collections-load-more',
  rangeSlider: '.price-range .range-slider',
  rangeSliderMin: '.range-slider-min',
  rangeSliderMax: '.range-slider-max',
  minPriceRange: '.min-price-range',
  maxPriceRange: '.max-price-range',
  collectionSidebar: '#CollectionSidebar',
  collectionFilterBlocks: '.filter-blocks',
  productgridcontainer: '#productgridcontainer',
  collectionFiltersForm: '#CollectionFiltersForm',
  section: '.sec__collection-main',
};

const collectionPreferences = {
  storagePrefix: 'jm-collection-preference',
  keys: {
    viewMode: 'view-mode',
    gridMode: 'grid-mode'
  },
  validViewModes: ['grid', 'list'],
  validGridModes: ['1', '2', '3', '4'],
  persistedViewModes: ['list'],
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this._handler = this.onOpen.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this._handler, false);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._handler, false);
  }
  onOpen() {
    if (!this.classList.contains('open')) {
      this.collectionSidebar.classList.add('open');
      document.documentElement.classList.add('open-drawer', 'open-sidebar');
      root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
      this.classList.add('open');
    } else {
      this.collectionSidebar.classList.remove('open');
      document.documentElement.classList.remove('open-drawer', 'open-sidebar');
      root.style.removeProperty('padding-right');
      this.classList.remove('open');
    }
  }
}
customElements.define('btn-filter', BtnFilter);
class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this._handler = this.onClose.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this._handler, false);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._handler, false);
  }
  onClose() {
    this.collectionSidebar.classList.remove('open');
    document.documentElement.classList.remove('open-drawer', 'open-sidebar');
    document.querySelector('.btn-filter').classList.remove('open');
    root.style.removeProperty('padding-right');
  }
}
customElements.define('close-filter', CloseFilter);

class FacetApplyCanvas extends CloseFilter { }
customElements.define('facet-apply-canvas', FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this._handler = this.gridMode.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this._handler, false);
    if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
    if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
    this.setAttribute('aria-pressed', this.classList.contains('active') ? 'true' : 'false');
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._handler, false);
  }
  async gridMode() {
    if (this.classList.contains('active')) return;
    const view_mode = this.getAttribute('data-grid-mode');
    if (typeof Motion !== "undefined" && Motion.animate) {
      await Motion.animate(
        document.querySelectorAll(
          'motion-element.product-item__wrapper.slide_in'
        ),
        {
          transform: ['translateY(0)', 'translateY(3.5rem)'],
          opacity: [1, 0.01],
          visibility: ['visible', 'hidden'],
        },
        {
          duration: 0.3,
          delay: Motion.stagger(0.05),
          easing: [0, 0, 0.3, 1],
        }
      );
    }


    for (var item of document.querySelectorAll('grid-mode')) {
      item.classList.remove('active');
      item.setAttribute('aria-pressed', 'false');
    }
    const container_switch = document.querySelector(
      '.container-products-switch'
    );
    this.classList.add('active');
    this.setAttribute('aria-pressed', 'true');
    const data_view_mode = container_switch.getAttribute('data-view-mode');
    container_switch.classList.remove('grid-columns-' + data_view_mode);
    container_switch.setAttribute('data-view-mode', view_mode);
    container_switch.classList.add('grid-columns-' + view_mode);
    eventCollectionShopify.removePreference(collectionPreferences.keys.viewMode);
    eventCollectionShopify.savePreference(collectionPreferences.keys.gridMode, view_mode);
    if (typeof Motion !== "undefined" && Motion.animate) {
      Motion.animate(
        document.querySelectorAll(
          'motion-element.product-item__wrapper.slide_in'
        ),
        {
          transform: ['translateY(3.5rem)', 'translateY(0)'],
          opacity: [0.01, 1],
          visibility: ['hidden', 'visible'],
        },
        {
          duration: 0.3,
          delay: Motion.stagger(0.1),
          easing: [0, 0, 0.3, 1],
        }
      );
    } else {
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ).forEach(function(el) {
        el.style.transform = 'translateY(0)';
        el.style.opacity = '1';
        el.style.visibility = 'visible';
      });
    }
  }
}
customElements.define('grid-mode', GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this._handler = this.viewMode.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this._handler, false);
    if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
    if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
    this.setAttribute('aria-pressed', this.classList.contains('active') ? 'true' : 'false');
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._handler, false);
  }
  viewMode() {
    const view_mode = this.getAttribute('data-view');
    if (this.classList.contains('actived')) return;
    if (view_mode === 'list') {
      eventCollectionShopify.savePreference(collectionPreferences.keys.viewMode, view_mode);
    } else {
      eventCollectionShopify.removePreference(collectionPreferences.keys.viewMode);
    }
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('view', queryString);
    if (view_mode == 'list') {
      var searchParams = queryString.replace('?', '') + '&view=list';
    } else {
      var searchParams = queryString.replace('?', '') + '&view=grid';
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams, {
      skipAutoAvailability: true
    });
  }
}
customElements.define('view-mode', ViewMode);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this._handler = this.filterItem.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this._handler, false);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._handler, false);
  }
  filterItem() {
    if (this.querySelector('.tooltip')) {
      this.querySelector('.tooltip').classList.toggle('current-filter');
    } else {
      if (this.closest('li')) {
        this.closest('li').classList.toggle('current-filter');
      }
    }
    /* Instant visual feedback */
    this.classList.add('is-loading');
    const url = this.getAttribute('data-href');
    const paramName = this.getAttribute('data-param-name');
    eventCollectionShopify.renderSectionFilter(url, '', {
      skipAutoAvailability: paramName === 'filter.v.availability',
      clearAutoAvailabilityFlag: paramName === 'filter.v.availability'
    });
  }
}
customElements.define('filter-item', FilterItem);

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this._handler = this.filterItem.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this._handler, false);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._handler, false);
  }
  filterItem() {
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url, '', {
      skipAutoAvailability: true,
      clearAutoAvailabilityFlag: true
    });
    this.onClose();
  }
}
customElements.define('facet-clear-all', FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this._handler = this.filterSort.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this._handler, false);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._handler, false);
  }
  filterSort() {
    const value = this.getAttribute('value');
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('sort_by', queryString);
    const searchParams = queryString.replace('?', '') + '&sort_by=' + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams, {
      skipAutoAvailability: true
    });
  }
}
customElements.define('filter-sort', FilterSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this._handler = this.activeFilterSort.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this._handler, false);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._handler, false);
  }
  activeFilterSort() {
    if (this.closest('.select-custom').classList.contains('active')) {
      this.closest('.select-custom').classList.remove('active');
    } else {
      this.closest('.select-custom').classList.add('active');
    }
  }
}
customElements.define('select-sorter', SelectSorter);

var eventCollectionShopify = (function () {
  return {
    init: function () {
      const { needsFetch, urlParams } = this.getRestoredSearchParams();
      this.ionRangeSlider();

      if (needsFetch) {
        const url = this.renderUrl(urlParams);
        this.renderSectionFilter(url, urlParams, {
          skipEnrichment: true,
          historyMode: 'replace',
        });
      } else {
        if (urlParams) {
          /* Only visual params like 'view' changed. Just update URL quietly */
          this.updateUrl(this.renderUrl(urlParams), urlParams, 'replace');
        }
        this.applySavedGridMode();
      }
      this.applyMobileHorizontalFilterState();

      /* BFCache & History Gold Standard: Listen for Browser Back/Forward */
      window.addEventListener('popstate', (event) => {
        const searchParams = window.location.search;
        const url = this.renderUrl(searchParams);
        /* Re-render the grid based on the URL we just popped back to */
        this.renderSectionFilter(url, searchParams, {
          skipEnrichment: true,
          isPopState: true
        });
      });
    },

    safeStorageKey: function (key) {
      return `${collectionPreferences.storagePrefix}:${key}`;
    },

    savePreference: function (key, value) {
      if (!key || value === undefined || value === null || value === '') return;
      try {
        window.localStorage.setItem(this.safeStorageKey(key), String(value));
      } catch (error) {
        return;
      }
    },

    getPreference: function (key) {
      if (!key) return null;
      try {
        return window.localStorage.getItem(this.safeStorageKey(key));
      } catch (error) {
        return null;
      }
    },

    removePreference: function (key) {
      if (!key) return;
      try {
        window.localStorage.removeItem(this.safeStorageKey(key));
      } catch (error) {
        return;
      }
    },

    getValidSortValues: function () {
      const values = new Set();
      document
        .querySelectorAll('filter-sort[value]')
        .forEach((item) => {
          const value = item.getAttribute('value');
          if (value) values.add(value);
        });
      return values;
    },

    parseSearchParams: function (searchParams, sourceUrl) {
      let rawSearch = searchParams;
      if ((!rawSearch || rawSearch === '') && sourceUrl) {
        try {
          rawSearch = new URL(sourceUrl, window.location.origin).search;
        } catch (error) {
          rawSearch = '';
        }
      }
      rawSearch = (rawSearch || '').replace(/^[?#&]+/, '');
      const params = new URLSearchParams(rawSearch);
      params.delete('section_id');
      return params;
    },

    enrichSearchParamsWithPreferences: function (searchParams, sourceUrl, options = {}) {
      const params = this.parseSearchParams(searchParams, sourceUrl);
      const currentView = params.get('view');
      const currentSort = params.get('sort_by');
      const validSortValues = this.getValidSortValues();

      if (collectionPreferences.persistedViewModes.includes(currentView)) {
        this.savePreference(collectionPreferences.keys.viewMode, currentView);
      } else if (currentView === 'grid') {
        this.removePreference(collectionPreferences.keys.viewMode);
      } else {
        const savedViewMode = this.getPreference(collectionPreferences.keys.viewMode);
        if (collectionPreferences.persistedViewModes.includes(savedViewMode)) {
          params.set('view', savedViewMode);
        } else if (savedViewMode) {
          this.removePreference(collectionPreferences.keys.viewMode);
        }
      }

      if (currentSort) {
        if (!validSortValues.has(currentSort)) {
          params.delete('sort_by');
        }
      }

      /* Default-on availability filter:
         Always show only in-stock products unless the customer explicitly
         opted out by clicking the availability toggle (stored in sessionStorage).
         When the customer clicks the availability filter OFF, we remember
         that choice for the session. Clicking it ON again clears the opt-out. */
      const isSkipBoolean = typeof options === 'boolean';
      const skipAutoAvailability = isSkipBoolean ? options : (options.skipAutoAvailability || false);
      const clearAutoAvailabilityFlag = isSkipBoolean ? options : (options.clearAutoAvailabilityFlag || false);

      /* GEÄNDERT: alle Schreibzugriffe auf mm:avail_opted_out spiegeln
         jetzt zusaetzlich die <html class="jm-show-oos"> wider, damit
         die CSS-Hide-Regel in critical.css live mit der Praeferenz
         synchronisiert ist (kein Page-Reload noetig). */
      if (clearAutoAvailabilityFlag) {
        /* Customer explicitly toggled the availability filter */
        if (params.has('filter.v.availability')) {
          /* Toggled ON → clear any previous opt-out */
          try { sessionStorage.removeItem('mm:avail_opted_out'); } catch (e) { }
          document.documentElement.classList.remove('jm-show-oos');
        } else {
          /* Toggled OFF → remember opt-out for this session */
          try { sessionStorage.setItem('mm:avail_opted_out', '1'); } catch (e) { }
          document.documentElement.classList.add('jm-show-oos');
        }
      }

      if (!skipAutoAvailability) {
        if (!clearAutoAvailabilityFlag && !params.has('filter.v.availability')) {
          /* Any non-availability filter action (e.g. size, color) clears the
             opt-out so availability=1 is re-applied automatically.
             Filtering by size only makes sense when showing in-stock items. */
          try { sessionStorage.removeItem('mm:avail_opted_out'); } catch (e) { }
          document.documentElement.classList.remove('jm-show-oos');
          params.set('filter.v.availability', '1');
        } else {
          let optedOut = false;
          try { optedOut = sessionStorage.getItem('mm:avail_opted_out') === '1'; } catch (e) { }

          if (!optedOut && !params.has('filter.v.availability')) {
            params.set('filter.v.availability', '1');
          }
        }
      }

      return params.toString();
    },

    getRestoredSearchParams: function () {
      const currentParams = this.parseSearchParams(window.location.search);
      const currentString = currentParams.toString();

      /* GEÄNDERT: Auto-Add von filter.v.availability beim Init wurde komplett
         abgeschaltet. Begruendung:
           - Interne Navigation: snippets/jm-collection-url.liquid haengt
             den Filter bereits Liquid-seitig in jeden Collection-Link an,
             sodass der allererste Server-Render gefiltert kommt.
           - Direkt-Entries (Google, Bookmark, externer Link): CSS-Hide
             via .product-item--unavailable + html.jm-show-oos uebernimmt
             das visuelle Filtering ohne zweiten Roundtrip.
           - Opt-out (mm:avail_opted_out): wird vom Sync-Script in
             layout/theme.liquid head + von jm-availability-links.liquid
             ueber die Klasse jm-show-oos und URL-Strip respektiert.
         Wuerde init hier nachträglich filter.v.availability ergaenzen,
         entstuende exakt der Doppel-AJAX-Render pro Direkt-Entry, den
         wir mit dem Wegnehmen des Sync-Redirects eliminieren wollten.
         View-Mode-/Sort-Restoring bleibt aktiv (laeuft in enrich
         unabhaengig von skipAutoAvailability). */
      const restoredString = this.enrichSearchParamsWithPreferences(
        currentString,
        null,
        { skipAutoAvailability: true }
      );

      if (restoredString !== currentString) {
        return {
          needsFetch: true,
          urlParams: restoredString
        };
      }
      return { needsFetch: false, urlParams: '' };
    },

    applySavedGridMode: function () {
      const params = this.parseSearchParams(window.location.search);
      if (params.get('view') === 'list') return;

      const savedGridMode = this.getPreference(collectionPreferences.keys.gridMode);
      if (!collectionPreferences.validGridModes.includes(savedGridMode)) return;

      const containerSwitch = document.querySelector('.container-products-switch');
      if (!containerSwitch) return;

      const currentGridMode = containerSwitch.getAttribute('data-view-mode');
      if (currentGridMode) {
        containerSwitch.classList.remove('grid-columns-' + currentGridMode);
      }
      containerSwitch.setAttribute('data-view-mode', savedGridMode);
      containerSwitch.classList.add('grid-columns-' + savedGridMode);

      document.querySelectorAll('grid-mode').forEach((item) => {
        item.classList.remove('active');
      });
      document
        .querySelectorAll(`grid-mode[data-grid-mode="${savedGridMode}"]`)
        .forEach((item) => item.classList.add('active'));
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector('.price-range');
      const maxRange = document.querySelector(
        options_collection.rangeSliderMax
      );
      const minRange = document.querySelector(
        options_collection.rangeSliderMin
      );
      const minPrice = document.querySelector('.min-price-range');
      const maxPrice = document.querySelector('.max-price-range');
      var minPriceRange = 0;
      var maxPriceRange = 0;
      if (!price_range || price_range.dataset.eventsBound === 'true') return;
      price_range.dataset.eventsBound = 'true';

      /* Debounced helper: fires the filter network request after the user
         stops changing the price input for 350ms. Prevents dozens of
         requests when dragging the range slider or typing quickly. */
      let _priceDebounceTimer = null;
      const debouncedPriceFilter = () => {
        clearTimeout(_priceDebounceTimer);
        _priceDebounceTimer = setTimeout(() => {
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute('name');
          const nameMax = maxPrice.getAttribute('name');
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace('?', '') + '&' + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        }, 350);
      };

      document.querySelector(options_collection.minPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(minRange.min) + Number(target.value) >= 0) {
            if (Number(target.value) > Number(maxRange.max)) {
              minPrice.value = Number(maxRange.max);
            } else {
              minPrice.value = Number(target.value);
            }
          } else {
            minPrice.value = Number(minRange.min);
          }
          debouncedPriceFilter();
        },
        false
      );
      document.querySelector(options_collection.maxPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(maxRange.max) - Number(target.value) >= 0) {
            maxPrice.value = Number(target.value);
          } else {
            maxPrice.value = Number(maxRange.max);
          }
          debouncedPriceFilter();
        },
        false
      );
      document
        .querySelector(options_collection.rangeSliderMin)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (Number(maxRange.value) - Number(target.value) >= 1) {
              minPrice.value = Number(target.value);
              minPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(maxRange.value) - 1;
              minPriceRange = (Number(maxRange.value) - 1) * 100;
            }
            const price_format = Shopify.formatMoney(
              minPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .min').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-from',
                (minRange.value / Number(target.getAttribute('max'))) * 100 +
                '%'
              );
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMax)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.value - minRange.value >= 1) {
              maxPrice.value = target.value;
              maxPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(minRange.value) + Number(1);
              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
            }
            const price_format = Shopify.formatMoney(
              maxPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .max').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-to',
                (maxRange.value / Number(target.getAttribute('max'))) * 100 +
                '%'
              );
          },
          false
        );
      document
        .querySelectorAll(options_collection.rangeSlider)
        .forEach((sliderRange) => {
          sliderRange.addEventListener(
            'change',
            (event) => {
              event.preventDefault();
              debouncedPriceFilter();
            },
            false
          );
        });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split('?')[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
      if (queryString !== '') {
        params_arr = queryString.split('&');
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split('=')[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const query = searchParams ? `&${searchParams}` : '';
      const url = `${window.location.pathname}?section_id=${sectionId}${query}`;
      return url;
    },

    /* AbortController for cancelling stale in-flight requests */
    _controller: null,

    renderSectionFilter: function (url, searchParams, options = {}) {
      try { sessionStorage.removeItem('jm_pg_html'); } catch (e) { }
      const skipEnrichment = options.skipEnrichment === true;
      const historyMode = options.historyMode === 'replace' ? 'replace' : 'push';
      const finalSearchParams = skipEnrichment
        ? this.parseSearchParams(searchParams, url).toString()
        : this.enrichSearchParamsWithPreferences(searchParams, url, options);
      const finalUrl = this.renderUrl(finalSearchParams);

      /* Capture previous URL to revert if fetch fails */
      const previousUrl = window.location.href;

      /* Update browser URL IMMEDIATELY for Gold Standard BFCache behavior */
      if (!options.isPopState) {
        this.updateUrl(finalUrl, finalSearchParams, historyMode);
      }

      /* Cancel any in-flight request so only the latest wins */
      if (this._controller) this._controller.abort();
      this._controller = new AbortController();

      this.toggleLoading(document.querySelector(options_collection.section), true);
      fetch(finalUrl, { signal: this._controller.signal })
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          /* Parse response only ONCE */
          const parsed = new DOMParser()
            .parseFromString(responseText, 'text/html');

          /* Targeted DOM replacement — only filter blocks + product grid */
          const newFilters = parsed.querySelector(options_collection.collectionFilterBlocks);
          const newGrid = parsed.querySelector(options_collection.productgridcontainer);

          if (newFilters) {
            /* Save filter accordion open/closed states before replacement */
            const filterContainer = document.querySelector(
              options_collection.collectionFilterBlocks
            );
            const savedFilterStates = [];
            filterContainer.querySelectorAll('collapsible-block').forEach(function (block, i) {
              var heading = block.querySelector('.collapsible-heading span');
              var labelNode = heading && heading.firstChild;
              savedFilterStates.push({
                index: i,
                label: labelNode ? labelNode.textContent.trim() : '',
                active: block.classList.contains('active')
              });
            });

            filterContainer.innerHTML = newFilters.innerHTML;

            /* Restore filter accordion states after replacement */
            filterContainer.querySelectorAll('collapsible-block').forEach(function (block, i) {
              var heading = block.querySelector('.collapsible-heading span');
              var labelNode = heading && heading.firstChild;
              var label = labelNode ? labelNode.textContent.trim() : '';
              var saved = savedFilterStates.find(function (s) { return s.label === label; });
              if (!saved) return;
              var content = block.querySelector('.collapsible-content');
              if (saved.active) {
                block.classList.add('active');
                if (content) content.style.display = '';
              } else {
                block.classList.remove('active');
                if (content) content.style.display = 'none';
              }
            });
          }
          if (newGrid) {
            document.querySelector(
              options_collection.productgridcontainer
            ).innerHTML = newGrid.innerHTML;
          }

          if (window.innerWidth <= 1024) {
            if (
              document
                .querySelector(options_collection.collectionSidebar)
                .classList.contains('open')
            ) {
              document.querySelector(options_collection.collectionSidebar).classList.remove('open')
            }
          }

          document.documentElement.classList.remove('hside_opened', 'open-drawer', 'open-sidebar');
          this.applySavedGridMode();

          const updatedContainer = document.querySelector(
            options_collection.productgridcontainer
          );
          const updatedFilterContainer = document.querySelector(
            options_collection.collectionFilterBlocks
          );
          document.dispatchEvent(
            new CustomEvent('theme:dom-updated', {
              detail: {
                container: updatedContainer || document,
              },
            })
          );

          if (typeof window.jmCfRefresh === 'function') {
            window.jmCfRefresh(updatedFilterContainer || document);
          } else if (typeof window.jmCfCheckOverflow === 'function') {
            window.jmCfCheckOverflow();
          }

          this.toggleLoading(document.querySelector(options_collection.section), false);
        })
        .catch((error) => {
          /* Silently ignore AbortError — expected when cancelling in-flight requests */
          if (error.name === 'AbortError') return;

          /* GEÄNDERT: URL nur dann reverten, wenn die aktuelle URL
             tatsaechlich noch unserem optimistischen pushState
             entspricht. Hat der User zwischenzeitlich einen anderen
             Filter geklickt (oder ueber den Browser navigiert), wuerde
             ein blindes replaceState seine neuere URL ueberschreiben
             und damit den sichtbaren Zustand zerstoeren. */
          if (!options.isPopState && window.location.href === finalUrl) {
            window.history.replaceState({ url: previousUrl }, '', previousUrl);
          }
          this.toggleLoading(document.querySelector(options_collection.section), false);

          throw error;
        })
        .finally(() => {
          const motionCollection = document.querySelector(".motion-collection");
          if (motionCollection && typeof motionCollection.reloadAnimationEffect === 'function') {
            motionCollection.reloadAnimationEffect();
          }
          initLazyloadItem();
          BlsLazyloadImg.init();
          eventCollectionShopify.ionRangeSlider();
          eventCollectionShopify.applyMobileHorizontalFilterState();
        });
    },

    applyMobileHorizontalFilterState: function () {
      if (window.innerWidth > 1024) return;
      const horizontal = document.querySelector('.horizontal-filter');
      if (!horizontal) return;
      horizontal.querySelectorAll('collapsible-block').forEach((item) => {
        item.classList.add('active');
        var content = item.querySelector('.collapsible-content');
        if (content) content.style.display = '';
      });
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add('start', 'loading');
        } else {
          event.classList.add('finish');
          setTimeout(function () {
            event.classList.remove('start', 'loading', 'finish');
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false, mode = 'push') {
      const historyMethod = mode === 'replace' ? 'replaceState' : 'pushState';
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history[historyMethod]({ url: urlUpdate }, '', urlUpdate);
      } else if (searchParams === '') {
        window.history[historyMethod](
          { url: window.location.pathname },
          '',
          window.location.pathname
        );
      } else {
        window.history[historyMethod]({ url: url }, '', url);
      }
    },
  };
})();
eventCollectionShopify.init();
